// Localization is based on '@ngx-translate/core';
// Please be familiar with official documentations first => https://github.com/ngx-translate/core

import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieComponent } from 'src/app/_c3-lib/kt/components';
import { ProfileContextService } from 'src/app/services/profile-context.service';

export interface Locale {
  lang: string;
  data: any;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];

  constructor(
    private translate: TranslateService,
    private profileContextService: ProfileContextService,

  ) {
    // add new langIds to the list
    this.translate.addLangs(['en']);

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
    this.translate.use(this.getSelectedLanguage());
  }

  setLanguage(lang: string) {
    if (lang) {
      if(lang=='en-us'){
        lang= 'en'
      }else if(lang=='cn'){
        lang= 'ch'
      }
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
      CookieComponent.set('LOCALIZATION_LOCAL_STORAGE_KEY', lang, {})

    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    let lang = this.profileContextService?.InfoDetails?.DefaultLanguageKey || '';
    if(lang=='en-us'){
      lang= 'en'
    }
    return (
      localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY) || CookieComponent.get('LOCALIZATION_LOCAL_STORAGE_KEY') || lang ||
      this.translate.getDefaultLang()
    );
  }
}
